
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/expedia",
      function () {
        return require("private-next-pages/destinations/expedia.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/expedia"])
      });
    }
  